export default __webpack_public_path__ + "static/media/logo_tm.1e272582.png";